import { Note, SendNote } from './../models/note';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, catchError } from 'rxjs';
import { environment as env } from '../environments/environment';
import { IUser, Email, IUserAdmin } from '../models/interfaces/user.model';
import { IResponse } from '../models/interfaces/response.model';
import { IEditRankBody, IRanks } from 'projects/admin/src/app/components/panel/users/interfaces/ranks';
import { StaffLoginResponse } from '../models/interfaces/staff';

@Injectable({
  providedIn: 'root',
})
export class UserService {
  apiURL = `${env.apiUrl}/users`;
  adminApiURL = `${env.apiUrl}admin/users`;
  apiURLProfile = `${env.apiUrl}auth`;
  apiURLStaff = `${env.apiUrl}staff/`;
  constructor(private http: HttpClient) { }
  getAllUsers(param: {} = {}): Observable<IResponse<IUserAdmin>> {
    const params = new HttpParams({ fromObject: param });
    return this.http.get<IResponse<IUserAdmin>>(`${this.adminApiURL}?${params}`);
  }
  getUserById(userId: string): Observable<IUserAdmin> {
    return this.http.get<IUserAdmin>(`${this.adminApiURL}/${userId}`);
  }
  updateUser(user: IUser, id?: string): Observable<IUserAdmin> {
    return this.http
      .patch<IUserAdmin>(`${this.adminApiURL}/${id}`, user)
      .pipe(
        catchError((err) => {
          throw new Error(err.message);
        })
      );
  }
  changeBanStatus(userId:string ,banStatus:string){
    return this.http.patch<IUser>(
      `${this.adminApiURL}/change-ban-status/${userId}`, {banStatus}
    );
  }
  addUserNote(note: SendNote): Observable<IUser> {
    return this.http.post<IUser>(
      `${this.adminApiURL}/add-user-note/${note.userId}`,
      note.note
    );
  }
  updateProfile(user: any): Observable<StaffLoginResponse> {
    return this.http.patch<StaffLoginResponse>(`${this.apiURLProfile}/update-profile`, user);
  }
  updateProfileAdmin(admin: any): Observable<StaffLoginResponse> {
    return this.http.patch<StaffLoginResponse>(`${this.apiURLStaff}admin-profile`, admin);
  }
  searchUsersByEmail(email: string): Observable<Email[]> {
    return this.http.get<any>(`${email}`);
  }
  // ! Ranks
  getRanks(): Observable<IRanks[]> {
    return this.http.get<IRanks[]>(`${env.apiUrl}rank`);
  }
  editRank(id: string , payload: IEditRankBody): Observable<IEditRankBody> {
    return this.http.put<IEditRankBody>(`${env.apiUrl}rank/${id}`, payload);
  }

  getFingerprintUsers(fingerprint: string): Observable<any> {
    return this.http.get(`${env.apiUrl}admin/users/track-by-fingerprint/${fingerprint}`)
  }

}
